import { ICheckoutModel } from "@/models";
import { getQueryStringValue } from "./getQueryStringValue";

export function setCheckoutFromQueryParams(
    checkout: ICheckoutModel,
    query: Record<string, string | (string | null)[]>
): void {
    checkout.shippingAddress = checkout.shippingAddress || {};

    const email = getQueryStringValue(query, "Email");
    if (email) {
        checkout.email = email;
    }

    const firstName = getQueryStringValue(query, "FirstName");
    if (firstName) {
        checkout.shippingAddress.firstName = firstName;
    }

    const lastName = getQueryStringValue(query, "LastName");
    if (lastName) {
        checkout.shippingAddress.lastName = lastName;
    }

    const address = getQueryStringValue(query, "Address1");
    if (address) {
        checkout.shippingAddress.address = address;
    }

    const address2 = getQueryStringValue(query, "Address2");
    if (address2) {
        checkout.shippingAddress.address2 = address2;
    }

    const city = getQueryStringValue(query, "City");
    if (city) {
        checkout.shippingAddress.city = city;
    }

    const state = getQueryStringValue(query, "State");
    if (state) {
        checkout.shippingAddress.state = state;
    }

    const zipCode = getQueryStringValue(query, "ZipCode");
    if (zipCode) {
        checkout.shippingAddress.zipCode = zipCode;
    }

    const phone = getQueryStringValue(query, "Phone");
    if (phone) {
        checkout.shippingAddress.phone = phone;
    }

    const cjEvent = getQueryStringValue(query, "cjevent");
    if (cjEvent) {
        checkout.cjEvent = cjEvent;
    }

    const utmSource = getQueryStringValue(query, "utm_source");
    if (utmSource) {
        checkout.utmSource = utmSource;
    }

    const utmContent = getQueryStringValue(query, "utm_content");
    if (utmContent) {
        checkout.utmContent = utmContent;
    }

    const utmCampaign = getQueryStringValue(query, "utm_campaign");
    if (utmCampaign) {
        checkout.utmCampaign = utmCampaign;
    }

    const utmMedium = getQueryStringValue(query, "utm_medium");
    if (utmMedium) {
        checkout.utmMedium = utmMedium;
    }

    const source = getQueryStringValue(query, "source");
    if (source) {
        checkout.source = source;
    }

    const roiValue = getQueryStringValue(query, "roi") as unknown;
    const roi = Array.isArray(roiValue) ? roiValue[0] : roiValue;
    if (typeof roi === "string") {
        checkout.isRoi = roi.toLowerCase() === "true";
    }

    const fbclid = getQueryStringValue(query, "fbclid");
    if (fbclid) {
        checkout.facebookClickId = fbclid;
    }
}
